// 增加元素
export const ADD_ELEMENT = 'ADD_ELEMENT'

// 删除所有元素
export const DELETE_ALL_ELEMENT = 'DELETE_ALL_ELEMENT'

// 选中某一个元素
export const SELECTED_ONE_ELEMENT = 'SELECTED_ONE_ELEMENT'
